import { Stack, styled } from '@mui/material';
import { useMemo } from 'react';
import { AvailabilityParsedItem } from './availability-calendar.types';
import { getAvailabilityGridLanes, SegmentLane } from './availability-grid-lanes';

export const AvailabilityGridCell = ({
  availabilityBlocks,
  handleClick,
}: {
  availabilityBlocks: AvailabilityParsedItem[];
  //Likely to change as the actions for other segment types become more common
  handleClick: (...args: any[]) => void;
}) => {
  const lanes = useMemo(() => getAvailabilityGridLanes(availabilityBlocks), [availabilityBlocks]);

  return (
    <StyledContainer direction="column" spacing={2} mt={1} mb={1}>
      {lanes.map((lane) => (
        <SegmentLane key={lane.testIdPrefix} handleClick={handleClick} {...lane} />
      ))}
    </StyledContainer>
  );
};

const StyledContainer = styled(Stack)({
  width: '100%',
  boxSizing: 'border-box',
  flexWrap: 'nowrap',
});
